import { getAccessToken } from '../utils/storage';
import { authFetch, getApiUrl } from '../utils/api';
import { friendlyApiError } from '../utils/apiErrors';

export interface LMSReconColumn {
  key: string;
  label: string;
  numeric?: boolean;
  hidden?: boolean;
  currency?: boolean;
  percent?: boolean;
}

export interface LMSReconReportResponse {
  key: string;
  title: string;
  rows: Record<string, unknown>[];
  columns: LMSReconColumn[];
  summary?: {
    row_count?: number;
    numeric_totals?: Record<string, number>;
    numeric_averages?: Record<string, number>;
    progress?: Record<string, { total: number; status_counts: Record<string, number> }>;
    filter_options?: Record<string, Array<string | number>>;
    default_filters?: Record<string, string | number>;
  };
}

const makeHeaders = (): Record<string, string> => {
  const token = getAccessToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

export const fetchLMSReconReport = async (
  reportKey: string,
  limit = 1000,
  filters: Record<string, string | number | undefined> = {},
): Promise<LMSReconReportResponse> => {
  const params = new URLSearchParams({ limit: String(limit) });
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      params.set(key, String(value));
    }
  });
  const response = await authFetch(getApiUrl(`/v1/lms-recon/${reportKey}?${params.toString()}`), {
    method: 'GET',
    headers: makeHeaders(),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(friendlyApiError(response.status, errorData.detail, 'The LMS Recon report'));
  }

  const data: LMSReconReportResponse = await response.json();
  return {
    ...data,
    rows: Array.isArray(data.rows) ? data.rows : [],
    columns: Array.isArray(data.columns) ? data.columns : [],
  };
};
